export default "__VITE_ASSET__DTYxjiiM__"